import Dto from "../../../../../lib/model/service/Dto";

class ReadCampaignFunctionList extends Dto {

  campaignId;

  constructor(campaignId = '') {
    super('appl\\service\\campaign\\dto\\ReadCampaignFunctionList');
    this.campaignId = campaignId;
  }

  getCampaignId() {
    return this.campaignId;
  }

  setCampaignId(campaignId) {
    this.campaignId = campaignId;
  }

}

export default ReadCampaignFunctionList;
